import { useContext } from 'react';
import AUTHcontext from './context';

const useAuth = () => useContext(AUTHcontext);

export default useAuth;
